// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"109":"37bd1e14","511":"8535493c","663":"fab53892"}[chunkId] + ".chunk.js";
};